import * as React from "react";

import {DraggableProvidedDragHandleProps} from "@hello-pangea/dnd";

import {zIndexClasses} from "@client/style";

import {Icon} from "@client/components/Icon";

type Props = {
    handle: DraggableProvidedDragHandleProps | null;
};

export const DragHandler = (props: Props) => (
    <span
        {...props.handle}
        className={`
            -m-3 flex min-h-full cursor-move items-center p-3 text-sm
            ${zIndexClasses.dragHandler}
        `}
    >
        <Icon icon="arrows" />
    </span>
);
